import get from 'lodash/get';

import { DEPENDENT_STATUSES } from '../constants/props';

export function dependentStatusCheck({
  id,
  guardianDependentsList,
  showDependentCreatedModal,
}) {
  const targetPerson = guardianDependentsList && guardianDependentsList.find(person => {
    if (person.dependent) {
      return person.dependent.id === id;
    }

    return person.id === id;
  });

  const status = get(targetPerson, 'status');
  const pending = status === DEPENDENT_STATUSES.PENDING;
  const unverified = status === DEPENDENT_STATUSES.UNVERIFIED;
  if (pending || unverified) {
    showDependentCreatedModal({
      messageId: `dependent.form.${
        pending ? 'createComplete' : 'unverifiedRequest'
      }`,
    });
    return false;
  }

  return true;
}



// WEBPACK FOOTER //
// ./src/utils/dependentStatusCheck.js